import { allStyles } from "@/constants/artStyles";
import { blogArticles } from "@/constants/blogArticles";

const PUBLIC_STATIC_PATHS = new Set([
  "/",
  "/tableau-photo-personnalise",
  "/photo-en-tableau",
  "/idees-cadeaux-photo-personnalises",
  "/portrait-animal-personnalise",
  "/portrait-chien-personnalise",
  "/portrait-chat-personnalise",
  "/portrait-cheval-personnalise",
  "/portrait-famille-personnalise",
  "/portrait-couple-personnalise",
  "/portrait-bebe-personnalise",
  "/decoration-murale-personnalisee",
  "/cadeau-anniversaire-photo-personnalise",
  "/cadeau-noel-photo-personnalise",
  "/cadeau-mariage-photo-personnalise",
  "/cadeau-grands-parents-photo-personnalise",
  "/cadeau-depart-retraite-photo-personnalise",
  "/blog",
  "/mentions-legales",
  "/politique-confidentialite",
  "/cgv",
]);

const PUBLIC_STYLE_PATHS = new Set(allStyles.map((style) => `/styles/${style.id}`));
const PUBLIC_BLOG_PATHS = new Set(blogArticles.map((article) => `/blog/${article.slug}`));

const normalizePathname = (pathname: string) => {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/+$/, "");
};

/**
 * Explicit allowlist: new routes stay out of search until their SEO metadata and
 * acquisition intent have been reviewed.
 */
export const isIndexableRoute = (pathname: string) => {
  const normalizedPathname = normalizePathname(pathname);

  return (
    PUBLIC_STATIC_PATHS.has(normalizedPathname) ||
    PUBLIC_STYLE_PATHS.has(normalizedPathname) ||
    PUBLIC_BLOG_PATHS.has(normalizedPathname)
  );
};
